<layout-container>
  <div *rxLet="state$ as state" class="flex flex-col flex-start-stretch gap-32">
    <div class="flex max-md:flex-col flex-auto gap-32 user-profile-container">
      @if (state.hasAccessToPersonalDetails) {
        <personal-details [canEdit]="state.canEdit" class="flex flex-col flex-[0_1_100%]"></personal-details>
      }
      @if (state.hasAccessToBusinessDetails || state.hasAccessToPreferredWorkLocations) {
        <div class="flex flex-col flex-[0_1_100%] gap-32">
          @if (state.hasAccessToBusinessDetails) {
            <business-details [canEdit]="state.canEdit"></business-details>
          }
          @if (state.hasAccessToPreferredWorkLocations) {
            <preferred-work-locations [canEdit]="state.canEdit"></preferred-work-locations>
          }
        </div>
      }
    </div>
    @if (state.hasAccessToTermsAndConditions) {
      <terms-and-conditions [canEdit]="state.canEdit"></terms-and-conditions>
    }
    @if (state.hasAccessToNotificationSettings) {
      <notification-settings [canEdit]="state.canEdit"></notification-settings>
    }
  </div>
</layout-container>
